/*
 * @Author: shijian.chen shijian.chen@qunar.com
 * @Date: 2022-07-30 17:36:38
 * @LastEditors: shijian.chen shijian.chen@qunar.com
 * @LastEditTime: 2023-01-03 17:15:21
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/picc2212/components/dialog/gift/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import Component from './index.vue'

let newInstance = null

//将vue组件变为构造函数
let ComponentConstructor = Vue.extend(Component)

let init = (options)=>{
    //实例化组件
    newInstance = new ComponentConstructor()
   //合并配置选项
    Object.assign(newInstance,options)
   //使用$mount()后  可以理解为创建虚拟的dom
    document.body.appendChild(newInstance.$mount().$el)
}
let dialogCommon = (options)=>{
    //options 为调用组件方法时传入的配置选项
    if(!newInstance){
        init(options)
    }
    newInstance.giftType = options.giftType || ""
    newInstance.getMoreTimes = options.getMoreTimes;
    newInstance.id = options.id || ""
    return newInstance.show(() =>{newInstance = null})
}
export default dialogCommon